export type RouteImporter = () => Promise<unknown>;

const prefetched = new Set<string>();

export function prefetchRoute(key: string, importer: RouteImporter): void {
  if (typeof window === "undefined") return;
  if (prefetched.has(key)) return;
  prefetched.add(key);

  const run = (): void => {
    void importer().catch(() => {
      prefetched.delete(key);
    });
  };

  const requestIdleCallback =
    "requestIdleCallback" in window
      ? (window.requestIdleCallback as (
          callback: () => void,
          options?: { timeout: number },
        ) => number)
      : undefined;

  if (requestIdleCallback !== undefined) {
    requestIdleCallback(run, { timeout: 2000 });
    return;
  }

  window.setTimeout(run, 200);
}

export function routeKeyFromPath(path: string): string {
  return path.split(/[?#]/, 1)[0] ?? path;
}
